//import logoImage from '../resources/img/blue-sky-logo.svg'
const siteName = '_krewinkel.studio'

const config = {
  //ogoImage,
  siteName
}

export default config
